export default __webpack_public_path__ + "static/media/login.0de96a59.png";